/**
 * to convert a object to graphql string query
 * e.g. obj = { a: "test" }
 * return would be `{ a: "test" }`
 * @param {*} obj 
 */
export function convertObjectToGraphQLQueryString (obj) {
  let query = '{'
  const keys = Object.keys(obj)
  // console.debug(keys)
  for (const key of keys) {
    // console.debug(key, ' ', obj[key], ' ', obj[key] instanceof Array)
    if (typeof obj[key] == 'number' || typeof obj[key] == 'boolean') {
      query += `${key}: ${obj[key]},`
    } else if (typeof obj[key] == 'string') {
      query += `${key}:${JSON.stringify(obj[key])},`
    } else if (obj[key] instanceof Array) {
      query += `${key}:[`
      for (const element of obj[key]) {
        if (typeof element == 'string') query += `${JSON.stringify(element)},`
        else if (typeof element == 'number' || typeof element == 'boolean') query += `${element},`
        else query += `${convertObjectToGraphQLQueryString(element)},`
      }
      if (obj[key].length == 0) {
        query += ','
      }
      query = `${query.substr(0, query.length - 1)}],`
    } else if (obj[key] instanceof Object) {
      query += `${key}:${convertObjectToGraphQLQueryString(obj[key])},`
    }
  }
  if (keys.length == 0) {
    query += ','
  }
  query = `${query.substring(0, query.length - 1)}}`
  return query
}

// TEST
// console.debug(convertObjectToGraphQLQueryString({num:10, test:'test\n', booleanTest: true, testArray: ['test', 10, { test3: 'test3', nestedObj: { test1: 'test1' } }], nestedObj: { test1: 'test1' }}))
// console.log(JSON.stringify("\\n"))